import uly from "ulysses/core";
import $ from "jquery";
import ko from "knockout";
import HalResource from "../api";
import "jquery-libs/jquery.validate";

"use strict";
ko.bindingHandlers.validate = {
    init: function(elt, va, bindings, model, context) {
        var validation = ko.unwrap(va());
        if (validation){
            $(elt).data("validation", validation);
            //force data properties for each rule.
            for (var rule in validation) {
                $(elt).data("rule" + rule.charAt( 0 ).toUpperCase() + rule.substring( 1 ).toLowerCase(), validation[rule]);
            }
            //$(elt).data("ruleValidate", validation);
        }
    }
};
$.validator.methods.maxlength = function( value, element, param ) {
        var length = Array.isArray( value ) ? value.length : this.getLength( value, element );
        return value == "" || length <= param;
    }
